import { AdacButton, AdacText } from '@adac-de/component-library';
import React, { RefObject } from 'react';
import { clsx } from 'clsx';
import styles from './slider-visual.module.scss';
import { Icon } from '@components/icons/icons';
import { useModal } from '@hooks/use-modal';
import Modal from '@components/modal/modal';
import { Richtext } from '@components/richtext/richtext';

type SliderVisualProps = {
  summaryValue: string;
  summaryLabel: string;
  subline?: string;
  showResults?: boolean;
  sectionInfo?: PvWizardSection['info'];
  modalRef?: RefObject<HTMLDivElement>;
  containerAsRow?: boolean;
};

export const SliderVisual: React.FC<React.PropsWithChildren<SliderVisualProps>> = ({
  summaryValue,
  summaryLabel,
  subline,
  showResults = true,
  sectionInfo,
  children,
  modalRef,
  containerAsRow
}) => {
  const { isOpen, toggle } = useModal();

  return (
    <div
      className={clsx({
        [styles.container]: true,
        [styles.containerFlexRow]: !!containerAsRow
      })}
    >
      {children}
      {showResults && (
        <div className={styles.summary}>
          <div className={styles.sectionResultSummary}>
            <AdacText bold className={styles.summaryText} data-testid="result-summary">
              {summaryValue}
            </AdacText>
            <AdacText type="medium" className={styles.summaryLabel}>
              {summaryLabel}
              {sectionInfo && (
                <>
                  <AdacButton
                    variant="unstyled"
                    onClick={toggle}
                    className={styles.summaryLabelInfo}
                  >
                    <Icon.Info />
                  </AdacButton>
                  <Modal isOpen={isOpen} close={toggle} modalRef={modalRef}>
                    <Richtext document={sectionInfo} textType="normal" />
                  </Modal>
                </>
              )}
            </AdacText>
          </div>
          {subline && (
            <AdacText type="medium" key={subline} className={styles.summarySubline}>
              {subline}
            </AdacText>
          )}
        </div>
      )}
    </div>
  );
};
